// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__h0ym5","label":"Completed_label__2AdMj"};